import { render, staticRenderFns } from "./userAgreement.vue?vue&type=template&id=24ac9552&scoped=true"
import script from "./userAgreement.vue?vue&type=script&lang=js"
export * from "./userAgreement.vue?vue&type=script&lang=js"
import style0 from "./userAgreement.vue?vue&type=style&index=0&id=24ac9552&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac9552",
  null
  
)

export default component.exports